'use client'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark, faAnchor, faArrowRight } from '@fortawesome/pro-solid-svg-icons'
import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@teqplay/ui'
import { useTranslations } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'

import { useAnalytics } from '@/app/lib/analytics'

import './ModalPortPerformance.scss'

export type TPropsModalPortPerformance = {
  isOpen: boolean
  onClose: () => void
}

const ModalPortPerformance = ({ isOpen, onClose }: TPropsModalPortPerformance) => {
  const t = useTranslations('VesselAlertCTA.portPerformanceCTA.modal')
  const { trackTeqplayRedirectCTA } = useAnalytics()

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent
        aria-describedby="port-performance-modal-description"
        className="dialog-port-performance"
      >
        <DialogClose asChild>
          <Button variant="neutral-tertiary" className="dialog-close-btn">
            <FontAwesomeIcon icon={faXmark} />
          </Button>
        </DialogClose>

        <DialogHeader className="dialog-port-performance-header">
          <DialogTitle asChild>
            <h2>
              <FontAwesomeIcon icon={faAnchor} />
              {t('title')}
            </h2>
          </DialogTitle>
        </DialogHeader>

        <div id="port-performance-modal-description" className="dialog-port-performance-section">
          <img
            src="https://teqplay.com/wp-content/uploads/2025/10/PTO-Dashboard-Summary-page-e1772627600142-2048x1186.png"
            alt={t('title')}
            width={600}
            height={400}
            className="dialog-port-performance-image"
          />
          <div className="dialog-port-performance-messages">
            <p className="dialog-port-performance-message">{t('section1.paragraph1')}</p>
            <p className="dialog-port-performance-message">{t('section1.paragraph2')}</p>
            <p className="dialog-port-performance-message">{t('section1.paragraph3')}</p>
            <p className="dialog-port-performance-message">{t('section1.paragraph4')}</p>
          </div>
        </div>

        <DialogFooter className="dialog-port-performance-footer">
          <Link
            href="https://teqplay.com/improve-performance/port-turnaround-optimization-solutions/"
            className="button brand-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackTeqplayRedirectCTA({
                source: 'port_performance_modal_section1',
                url: 'https://teqplay.com/improve-performance/port-turnaround-optimization-solutions/'
              })
            }
          >
            {t('section1.button')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </DialogFooter>

        <div className="dialog-port-performance-section">
          <img
            src="https://teqplay.com/wp-content/uploads/2026/03/mockup.png"
            alt={t('section2.message')}
            width={600}
            height={400}
            className="dialog-port-performance-image"
          />
          <p className="dialog-port-performance-message">{t('section2.message')}</p>
        </div>

        <DialogFooter className="dialog-port-performance-footer">
          <Link
            href="https://teqplay.com/port-benchmarks/"
            className="button brand-primary"
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              trackTeqplayRedirectCTA({
                source: 'port_performance_modal_section2',
                url: 'https://teqplay.com/port-benchmarks/'
              })
            }
          >
            {t('section2.button')}
            <FontAwesomeIcon icon={faArrowRight} />
          </Link>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ModalPortPerformance
